<template>
  <div class="row">
    <div class="col-12">
      <PedidoForm v-model="pedido" ref="pedido_form" @send="onSendData($event)"/>
    </div>
  </div>
</template>

<script>
import PedidoForm from "@/pages/views/pedidos/PedidoForm";
import Pedido from '@/models/pedidos/Pedido'
import {getResponse} from "@/util/utilities";

export default {
  name: "PedidosAdd",

  components: {
    PedidoForm
  },

  data(){
    return {
      pedido: new Pedido()
    }
  },

  mounted(){
    let vm = this;
  },

  methods: {
    async onSendData(payload)
    {
      this.$lock(this.$t('app.modules.orders.add.sending_data'));

      let data = new FormData();

      data.append('files', payload.orden);
      data.append('param', JSON.stringify(payload));

      try {
        let addPedidoRequest = await this.$http.post(route('Pedidos/AddPedidoBunch'), data);
        let response = getResponse(addPedidoRequest, null);

        if (response === null)
        {
          throw new Error();
        }

        await this.$router.push({name: 'Pedidos'});
      }
      catch (e)
      {
        this.notifyMessage('danger', 'Sucedió un error al guardar la información');
      }

      this.$swal.close();
    }
  }
};
</script>
